import React from 'react'
import './index.scss'
import { getCookie } from 'AccountsUtils'
import playStore from '../../../assets/images/playStore.png'
import appStore from '../../../assets/images/appStore.png'
import { checkMobileDevice } from '../../../utils/validator'
import { getMappedValue } from '../../../utils/arabicUtils'

const FlyinFooter = () => {
  const currentYear = new Date().getFullYear()
  const isRTL = getCookie('selectedLanguage') === 'ar'

  if (checkMobileDevice()) {
    return (
      <footer
        className="mobile-footer bg-navy-900 text-gray-200 "
        style={{ position: 'relative', marginTop: '50px' }}
      >
        <div className="container mx-auto px-4">
          {/* Navigation Links */}
          <div className="mobile-nav-links">
            <a href="/aboutUs.en.html" className="mobile-nav-link">
              {getMappedValue('About Us')}
            </a>
            <a href="/faqs.en.html" className="mobile-nav-link">
              {getMappedValue('FAQ')}
            </a>
            <a href="/contactUs.en.html" className="mobile-nav-link">
              {getMappedValue('Contact Us')}
            </a>
            <a href="/flyin-wallet.en.html" className="mobile-nav-link">
              {getMappedValue('Flyin Wallet')}
            </a>
            <a href="/flyin-franchise.en.html" className="mobile-nav-link">
              {getMappedValue('Flyin Franchise')}
            </a>
            <a
              href="https://extranet.flyin.com/#/hotels/suppliers/edit"
              className="mobile-nav-link"
            >
              {getMappedValue('Add Your Property')}
            </a>
            <a href="https://careers.flyin.com/" className="mobile-nav-link">
              {getMappedValue('Careers')}
            </a>
          </div>

          {/* App Download Section */}
          <div className="mobile-app-download">
            <a
              href="https://play.google.com/store/apps/details?id=com.flyin.bookings"
              className="app-store-link"
            >
              <img
                src={playStore}
                alt={getMappedValue('Google Play')}
                className="app-store-img"
              />
            </a>
            <a
              href="https://itunes.apple.com/us/app/flyin.com-tyran-w-fnadq/id1106268318"
              className="app-store-link"
            >
              <img
                src={appStore}
                alt={getMappedValue('App Store')}
                className="app-store-img"
              />
            </a>
          </div>

          {/* Social Media Icons */}
          <div className="mobile-social-icons">
            <a
              href="https://www.facebook.com/flyin.com"
              className="social-icon"
            >
              <i className="fab fa-facebook" />
            </a>
            <a href="https://twitter.com/flyincom" className="social-icon">
              <i className="fab fa-twitter" />
            </a>
            <a
              href="https://www.linkedin.com/company/flyin-com"
              className="social-icon"
            >
              <i className="fab fa-linkedin" />
            </a>
            <a
              href="https://www.instagram.com/flyincom/"
              className="social-icon"
            >
              <i className="fab fa-instagram" />
            </a>
            <a
              href="https://www.youtube.com/user/FlyinVideos"
              className="social-icon"
            >
              <i className="fab fa-youtube" />
            </a>
          </div>

          {/* Copyright and VAT */}
          <div className="mobile-copyright">
            <img
              className="vat-img"
              src="https://ui.cltp.co/flyin-static/img/vat-cert-logo.png"
              alt={getMappedValue('VAT Certificate')}
            />
            <span className="copyright-text">© {currentYear} Flyin.com</span>
          </div>
        </div>
      </footer>
    )
  }

  // Return the original desktop footer if not mobile
  return (
    <footer
      style={{ zIndex: '10' }}
      className="w-full bg-navy-900 text-gray-200"
    >
      <div className="container mx-auto px-4">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-start pt-6 border-b border-gray-700">
          {/* Subscribe Section */}
          <div className="w-full md:w-1/3 mb-6 md:mb-0">
            <a
              href="javascript:void(0);"
              className="SubLink flex items-center text-gray-300 hover:text-white"
            >
              <i className="fas fa-envelope w-4 h-4 mr-2" />
              {getMappedValue('Subscribe to our new offers')}
            </a>
          </div>

          {/* Browse Hotels */}
          <div className="mb-6 md:mb-0">
            <a
              href="/property/countries.en.html"
              className="BHotels text-gray-300 hover:text-white"
            >
              {getMappedValue('Browse Hotels By Country')}
            </a>
          </div>
          <div className="col1" />
          {/* Social Icons */}
          <div
            className="social-icons flex space-x-4"
            style={{ gap: '0px', gridGap: '0px' }}
          >
            <a
              href="https://www.facebook.com/flyin.com"
              className="hover:text-blue-400"
            >
              <i className="fab fa-facebook text-2xl" />
            </a>
            <a
              href="https://twitter.com/flyincom"
              className="hover:text-blue-400"
            >
              <i className="fab fa-twitter text-2xl" />
            </a>
            <a
              href="https://www.linkedin.com/company/flyin-com"
              className="hover:text-blue-400"
            >
              <i className="fab fa-linkedin text-2xl" />
            </a>
            <a
              href="https://www.instagram.com/flyincom/"
              className="hover:text-pink-400"
            >
              <i className="fab fa-instagram text-2xl" />
            </a>
            <a
              href="https://www.youtube.com/user/FlyinVideos"
              className="hover:text-red-500"
            >
              <i className="fab fa-youtube text-2xl" />
            </a>
          </div>
        </div>

        {/* Main Links Section */}
        <div className="pb-8 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex">
            {/* Links */}
            <div
              className="space-y-4 flex mainFootLinks"
              style={{ flexDirection: 'column' }}
            >
              <div>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="/flyin-wallet.en.html"
                      className="hover:text-white"
                    >
                      {getMappedValue('Flyin Wallet')}
                    </a>
                  </li>
                  <li>
                    <a href="/contactUs.en.html" className="hover:text-white">
                      {getMappedValue('Contact Us')}
                    </a>
                  </li>
                </ul>
              </div>

              <br />
              <div>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="https://extranet.flyin.com/#/hotels/suppliers/edit"
                      className="hover:text-white"
                    >
                      {getMappedValue('Add Your Property')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-4 pr-4" />

            {/* Mobile App Section */}
            <div className="col-span-2 footerAirlines">
              <h5 className="text-xl mb-4 fs-20">
                {getMappedValue('Flight & Hotels in one place')}
              </h5>
              <span className="block text-sm fs-12 text-gray-200 mb-4">
                {getMappedValue(
                  "Download our app now! Just a few clicks and you're done!"
                )}
              </span>
              <div className="flex pt-4 space-x-4">
                <a
                  href="https://play.google.com/store/apps/details?id=com.flyin.bookings"
                  className="w-32"
                >
                  <img
                    style={{ height: '40px' }}
                    src={playStore}
                    alt={getMappedValue('Google Play')}
                    className="w-full"
                  />
                </a>
                <a
                  href="https://itunes.apple.com/us/app/flyin.com-tyran-w-fnadq/id1106268318"
                  className="w-32"
                >
                  <img
                    style={{ height: '40px' }}
                    src={appStore}
                    alt={getMappedValue('App Store')}
                    className="w-full"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="py-6 border-t border-gray-700 copyRfooter">
          <div className="flex flex-col md:flex-row justify-between items-center">
            {/* Footer Links */}
            <div className="flex flex-wrap mb-4 md:mb-0 listInline">
              <a href="/aboutUs.en.html" className="text-sm hover:text-white">
                {getMappedValue('About Us')}
              </a>
              <a href="/faqs.en.html" className="text-sm hover:text-white">
                {getMappedValue('FAQ')}
              </a>
              <a
                href="/privacyPolicy.en.html"
                className="text-sm hover:text-white"
              >
                {getMappedValue('Privacy Policy')}
              </a>
              <a
                href="/termsOfUse.en.html"
                className="text-sm hover:text-white"
              >
                {getMappedValue('Terms of Use')}
              </a>
              <a href="/howTo.en.html" className="text-sm hover:text-white">
                {getMappedValue('File a Claim')}
              </a>
              <a
                href="https://careers.flyin.com/"
                className="text-sm hover:text-white"
              >
                {getMappedValue('Careers')}
              </a>
            </div>

            {/* Payment Methods */}
            <div className="flex items-center space-x-4">
              <div className="footerImg">
                <img
                  className="img-responsive lozad"
                  alt={getMappedValue('Paypal')}
                  data-src="https://ui.cltp.co/flyinstatic/common/themes/v2/img/support-cards.png"
                  src="https://ui.cltp.co/flyinstatic/common/themes/v2/img/support-cards.png"
                  data-loaded="true"
                />
              </div>

              <div className="flex items-center">
                <span className="text-sm">
                  © {currentYear} {getMappedValue('Saudi Ebreez Company')}
                </span>
                <div className="ml-3">
                  <a
                    href="https://ui.cltp.co/flyin-static/docs/flyin-VAT-cert.pdf"
                    target="_blank"
                  >
                    <img
                      width="28"
                      height="28"
                      className="img-responsive lozad"
                      alt={getMappedValue('Paypal')}
                      data-src="https://ui.cltp.co/flyin-static/img/vat-cert-logo.png"
                      src="https://ui.cltp.co/flyin-static/img/vat-cert-logo.png"
                      data-loaded="true"
                      style={{ verticalAlign: 'middle' }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default FlyinFooter
